import React, {useEffect, useState} from 'react';
import { ReactSVG } from 'react-svg';
import { getPublicImagePath, ToggleMenu, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';
import { WebsiteActions } from '../state/actions.mjs';
import togglePageLock from '../utils/togglePageLock';
import Href from './Href';

const componentClass = 'header';

// eslint-disable-next-line react/prop-types
const Header = ({ useBorderLine }) => {
    const appDispatch = useAppDispatch();
    const { accountState = {} } = useAppState();
    const { isActive: accountModalIsActive } = accountState;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuButtonClasses = classnames(`${componentClass}__menu-btn`, {
        isMenuOpen: isMenuOpen
    });
    const accountButtonClasses = classnames(`${componentClass}__account-icon`, 'd-none', {
        isMenuOpen: isMenuOpen
    });
    const toggleMenuClasses = classnames(`${componentClass}__menu}`, {
        useBorderLine
    });

    useEffect(() => {
        if (isMenuOpen) {
            togglePageLock(true);
        } else {
            togglePageLock(false);
        }

        return () => {
            togglePageLock(false);
        }
    }, [isMenuOpen]);

    const onAccountButtonClick = () => {
        if (!accountModalIsActive) {
            togglePageLock(true);
            appDispatch({ type: WebsiteActions.ACCOUNT_MODAL_SHOW });
        }
    };

    const closeTheMenu = () => setIsMenuOpen(false);

    return <React.Fragment>
        <header className={componentClass}>
            <ReactSVG src={getPublicImagePath('logo--wide.svg')} className={`${componentClass}__logo`} />
            <ToggleMenu isOpen={isMenuOpen} animation="slideFromRight" onOuterClick={closeTheMenu} className={toggleMenuClasses}>
                <div className="nuMenu">
                    <Href onClick={closeTheMenu} url="/#!">Music</Href>
                    <Href onClick={closeTheMenu} url="/#!">Videos</Href>
                    <Href onClick={closeTheMenu} url="/#!">Shop</Href>
                </div>
            </ToggleMenu>
        </header>
        <div className={`${componentClass}__fadedTop`} />
        <span className={accountButtonClasses} role="button" onClick={onAccountButtonClick}>
            <ReactSVG src={ getPublicImagePath('account-icon.svg') } />
        </span>
        <div className={menuButtonClasses} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            { isMenuOpen ? <ReactSVG src={ getPublicImagePath('close-icon.svg') } /> : <ReactSVG src={ getPublicImagePath('menu-icon.svg') } /> }
        </div>
    </React.Fragment>
};

export default Header;
